import { render, staticRenderFns } from "./reviewDetails.vue?vue&type=template&id=4b569864&scoped=true"
import script from "./reviewDetails.vue?vue&type=script&lang=js"
export * from "./reviewDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b569864",
  null
  
)

export default component.exports